// extracted by mini-css-extract-plugin
module.exports = {"layout-container":"index_layout-container_2oZYL","body":"index_body_2enlK","left":"index_left_3tmqw","content":"index_content_zlvL3"};